import axios from 'axios';
import authHeader from '../auth-header';
// Pakai tag ini kalau mau nge post file
import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

/**
 *
 * FILE INI BERFUNGSI UNTUK MENAMPUNG SEMUA FUNGSI REQUEST API
 * ?page=1&size=5' pakai ini untuk fungsi pagination
 * 
 * 
**/
const getLevel = 'level-anggota';
const postLevelUrl = 'level-anggota';
const putLevel = 'level-anggota/';
const deleteLevel = 'level-anggota/';

class LevelService {

    postLevel(formData) {
        /**
         *
         * API URL : BASE URL DARI BACKEND APINYA
         * formData : data yang mau di send ke database
         * { headers: authHeader() } ==> pakai ini untuk tokennya agar bisa dapat izin akses ke API
         * 
        **/
        return axios
        .post(
            API_URL + postLevelUrl,        // url post level
            formData,                   // data yang ingin di post
            { headers: authHeader() }   // Bearer Token
        );
    }

    putLevel(formData) {
        var headers = authHeader(); 
        /**
         *
         * Kalau ingin update data gunakan method put()
         * 
        **/
        return axios
        .put(
            API_URL + putLevel + formData.idLevelAnggota, formData,
            { headers: authHeader() }
        );
    }

    deleteLevel(formData) {
        var headers = authHeader(); 
        /**
         *
         * Kalau ingin delete data gunakan method delete()
         * 
        **/
        return axios
        .delete(
            API_URL + deleteLevel + formData.idLevelAnggota,
            { headers: authHeader() }
        );
    }

    getLevel(currentPage, pageSize,filter){
        /**
         *
         * Kalau hanya ingin menampilkan data gunakan method get()
         * 
        **/
        return axios.get(
            API_URL + getLevel + '?pageNo=' + currentPage + '&pageSize=10' + pageSize + '&filter=' + filter,
            { headers: authHeader() }
        );
    }

    getAllLevel()
    {
        /**
         *
         * Kalau hanya ingin menampilkan data gunakan method get()
         * 
        **/
        return axios.get(
            // API_URL + getLevel + '?page='+currentPage + 'size=10', 
            API_URL + getLevel + '?pageNo=0&pageSize=500',
            { headers: authHeader() 
        });
    }

    getAll() {
        return axios.get(
            API_URL + getLevel,
            {
                headers: authHeader()
            });
    }

}

export default new LevelService();
